// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__bLqC5","search":"MainPage_search__XEuFE","content":"MainPage_content__2z3WO"};